import { BASE_URL } from "config";
import * as baseApi from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/city/`,
    detail: (id) => `${BASE_URL}/api/v1/city/${id}/`,
};

export const cityLoad = (token, payload) => baseApi.ListLoad(endpoints.list, token, payload);
export const cityDetailLoad = (token, { id }) => baseApi.DetailLoad(endpoints.detail, token, { id });
export const cityUpdate = (token, data) => baseApi.Update(endpoints.list, endpoints.detail, token, data);
export const cityDelete = (token, { id }) => baseApi.Delete(endpoints.detail, token, { id });
